module.exports = __webpack_public_path__ + "img/thirdpartyModal.bdeaf607.svg";